import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import DataTable from "react-data-table-component";
import { tableHeaderStyles } from "../../../styles/ReactSelectStyles";
import { AppVersionColumns } from "../../../data/reports/AppVersionList";
import FilterAppVersionSection from "./FilterAppVersionSection";

const AppVersionDummyData = [
  {
    id: 1,
    image: "dashboard-8/user1.png",
    userName: "John Doe",
    role: "Sales",
    os: "Android 13",
    appName: "CRM Pro",
    currentVersion: "2.1.3",
    latestVersion: "2.2.0",
    organization: "Linnk group",
  },
  {
    id: 2,
    image: "dashboard-8/user2.png",
    userName: "Jane Smith",
    role: "Developer",
    os: "iOS 16.5",
    appName: "DevTools",
    currentVersion: "3.5.0",
    latestVersion: "3.5.0",
    organization: "Tech Solutions",
  },
  {
    id: 3,
    image: "dashboard-8/user3.png",
    userName: "Alice Johnson",
    role: "Finance",
    os: "iOS 17.1",
    appName: "FinanceApp",
    currentVersion: "1.0.8",
    latestVersion: "1.1.0",
    organization: "Linnk group",
  },
  {
    id: 4,
    image: "dashboard-8/user1.png",
    userName: "Bob Williams",
    role: "Developer",
    os: "Android 14",
    appName: "DevTools",
    currentVersion: "3.4.5",
    latestVersion: "3.5.0",
    organization: "Linnk group",
  },
  {
    id: 5,
    image: "dashboard-8/user2.png",
    userName: "Emma Brown",
    role: "Sales",
    os: "Android 12",
    appName: "CRM Pro",
    currentVersion: "2.0.1",
    latestVersion: "2.2.0",
    organization: "Innovate Inc.",
  },
  // ... other data entries with 'organization' property
];

interface AppVersionReportListProps {
  selectedAppName: string;
  setSelectedAppName: (value: string) => void;
  selectedVersion: string;
  setSelectedVersion: (value: string) => void;
  searchWord: string;
  setSearchWord: (value: string) => void;
  selectedOrganization: string;
  setSelectedOrganization: (value: string) => void;
}

function AppVersionReportList({
  selectedAppName,
  setSelectedAppName,
  selectedVersion,
  setSelectedVersion,
  searchWord,
  setSearchWord,
  selectedOrganization,
  setSelectedOrganization,
}: AppVersionReportListProps) {
  const { t } = useTranslation();

  const filteredItems = AppVersionDummyData.filter((item) => {
    const search = searchWord.toLowerCase();
    const matchesSearch =
      (item.userName && item.userName.toLowerCase().includes(search)) ||
      (item.role && item.role.toLowerCase().includes(search)) ||
      (item.os && item.os.toLowerCase().includes(search));

    const matchesAppName =
      !selectedAppName || (item.appName && item.appName === selectedAppName);

    const matchesVersion =
      !selectedVersion ||
      selectedVersion === "All" ||
      (selectedVersion === "Latest" &&
        item.currentVersion === item.latestVersion) ||
      (selectedVersion === "Old" && item.currentVersion !== item.latestVersion);

    const matchesOrganization =
      !selectedOrganization || item.organization === selectedOrganization;

    return (
      matchesSearch && matchesAppName && matchesVersion && matchesOrganization
    );
  });

  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <FilterAppVersionSection
                hideOrganization={true}
                showUserActions={false}
                onAddUser={() => {}}
                onInvite={() => {}}
                selectedAppName={selectedAppName}
                setSelectedAppName={setSelectedAppName}
                selectedVersion={selectedVersion}
                setSelectedVersion={setSelectedVersion}
                searchWord={searchWord}
                setSearchWord={setSearchWord}
                selectedOrganization={selectedOrganization}
                setSelectedOrganization={setSelectedOrganization}
              />

              <DataTable
                data={filteredItems}
                columns={AppVersionColumns(t)}
                striped
                pagination
                customStyles={tableHeaderStyles}
                pointerOnHover
                highlightOnHover
                noDataComponent={
                  <div className="text-center p-4 text-muted">
                    {t("NoAppVersionDataMessage")}
                  </div>
                }
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default AppVersionReportList;
